import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-full flex flex-col items-center justify-center text-center text-white px-8" }
const _hoisted_2 = {
  key: 0,
  class: "text-lg font-semibold"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center gap-4"
}
const _hoisted_4 = { class: "text-xl font-semibold" }
const _hoisted_5 = { class: "text-base opacity-70" }

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { IonContent } from '@ionic/vue';

import { consumeSafetyBrowserHandoff } from '@/modules/safety/composables/useSafetyBrowserHandoff';
import { useAuthStore } from '@/stores/auth/authStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'BrowserHandoffPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const { t } = useI18n();
const failed = ref(false);

const token = route.params.token?.toString() ?? '';

const normalizeRedirectPath = (redirectPath?: string | null): string => {
	if (!redirectPath || !redirectPath.startsWith('/safety')) {
		return '/safety';
	}

	return redirectPath;
};

onMounted(async () => {
	if (!token) {
		failed.value = true;
		return;
	}

	try {
		const handoff = await consumeSafetyBrowserHandoff(token);
		await authStore.saveToken({ token: handoff.token });
		await router.replace(normalizeRedirectPath(handoff.redirect_path));
	} catch {
		failed.value = true;
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), { class: "ion-padding" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!failed.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('safety.browser_handoff.loading')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('safety.browser_handoff.failed_title')), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('safety.browser_handoff.failed_body')), 1),
              _createElementVNode("button", {
                class: "px-6 py-3 rounded-full bg-white text-black font-semibold",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/auth/signinhome')))
              }, _toDisplayString(_unref(t)('safety.browser_handoff.sign_in')), 1)
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})